import { axiosEduServer } from "../utils/configAxios";

export const crearEstudiante = (data) => {
  return axiosEduServer.post('/estudiante', data).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const actualizarEstudiante = (id, data) => {
  return axiosEduServer.put(`/estudiante/${id}`, data).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const eliminarEstudiante = (id) => {
  return axiosEduServer.delete(`/estudiante/${id}`).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const getOneEstudiante = (id) => {
  return axiosEduServer.get(`/estudiante/${id}`).then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

export const getAllEstudiantes = () => {
  return axiosEduServer.get('/estudiante').then(({ data }) => data).catch((err) => { console.log(err); throw err });
};

// Registro masivo de estudiantes (envía archivo Excel via multipart/form-data)
export const registrarEstudiantesMasivo = (file) => {
  const form = new FormData();
  form.append('file', file);
  return axiosEduServer
    .post('/estudiante/registrar-estudiantes-masivo', form, {
      headers: { 'Content-Type': 'multipart/form-data' },
    })
    .then(({ data }) => data)
    .catch((err) => { console.log(err); throw err });
};